<template>
  <v-dialog v-model="isSuccessModalVisible" persistent max-width="458">
    <v-card style="padding: 10px 5px 10px 0">
      <v-card-text>
        <v-layout row="wrap">
          <v-spacer />
          <v-flex
            shrink
            style="cursor: pointer"
            @click="(isSuccessModalVisible = false), reload()"
          >
            <v-img
              src="@/assets/close.svg"
              aspect-ratio="1.7"
              width="14"
              height="14"
            ></v-img>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text style="padding: 0 27px 0">
        <v-layout align-center>
          <v-flex shrink mr-5>
            <v-img
              :src="require(`@/assets/imgs/${image}.png`)"
              aspect-ratio="1.7"
              width="73"
              height="73"
            ></v-img>
          </v-flex>
          <v-flex>
            <p class="alert-text">{{ text }}</p>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="#6CC8A0"
          style="color: #fff"
          @click="(isSuccessModalVisible = false), reload()"
          >OK</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isSuccessModalVisible: Boolean,
    image: String,
    text: String
  },
  data() {
    return {
      // isSuccessModalVisible: false
    };
  },
  methods: {
    reload() {
      window.location.reload();
    }
  }
};
</script>
